import { gqlPromise, type DefaultContext } from '@egw/clients'
import { type InvestmentAccountActivityInput, type InvestmentAccountActivity } from '../../../models'

/**
 * Get Investment Account Detail
 * @param investmentAccountActivityInput - alias: number
 * @param context - reference to the AbortController used to abort the call (optional)
 * @returns Promise<InvestmentAccountDetail>
 * @example const investmentAccountActivity = await getInvestmentAccountActivity();
 */
export const getInvestmentAccountActivity = async (
  investmentAccountActivityInput: InvestmentAccountActivityInput,
  context?: DefaultContext,
): Promise<InvestmentAccountActivity> => {
  const response = (await gqlPromise(
    {
      name: 'investmentAccountActivity',
      query: `query investmentAccountActivity($investmentAccountActivityInput: InvestmentAccountActivityInput) {
        investmentAccountActivity(investmentAccountActivityInput: $investmentAccountActivityInput) {
            activity {
                __typename
                activityId
                displayName
                date
                amount {
                amount
                currencyCode
                }
                ... on InvestmentTransferActivityDetailV2 {
                initiatedAmount {
                    amount
                    currencyCode
                }
                settledAmount {
                  amount
                  currencyCode
                }
                transferType
                transferStatus
                counterparty
                accountName
                initiatedDate
                completedDate
                trades {
                    tradeId
                    displayName
                    symbol
                    amount
                    amountType
                    status
                    side
                  }
                }
                ... on InvestmentDividendActivityDetailV2 {
                   activityId
                  displayName
                  date
                  amount {
                    amount
                    currencyCode
                  }
                  amountPerShare {
                    amount
                    currencyCode
                  }
                  symbol
                  instrumentName
                  trades {
                    tradeId
                    displayName
                    symbol
                    amount
                    amountType
                    status
                    side
                  }
                }
                ... on InvestmentFeeActivityDetail {
                  initiatedDate
                  completedDate 
                }
                ... on InvestmentInterestActivityDetail {
                  trades {
                    tradeId
                    displayName
                    symbol
                    amount
                    amountType
                    status
                    side
                  }
                }
                ... on InvestmentAcatGroupActivityDetailV2 {
                  sourceAccount
                  destinationAccount
                  transfers {
                    __typename
                    displayName
                    direction
                    amount {
                      amount
                      currencyCode
                    }

                    ... on InvestmentActivityAcatStock {
                      instrumentName
                      quantity
                      symbol
                    }
                  } 
                }
            }
        }
    }`,
    },
    { investmentAccountActivityInput },
    context,
  )) as { investmentAccountActivity: InvestmentAccountActivity }
  return response.investmentAccountActivity
}
